import React from "react";
import style from "./style.module.scss";
import { useAppSelector } from "../../../../../store";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import appConfig from "../../../../../util/appConfig";
import Ebwo from "./ebwo";
import Lra from "./lra";
import Calw from "./calw";
import { statuses } from "../../../../AdminSperrmuelanmeldungen";
import { AdminDetailInfoItem } from "../../../../../components";
import Leverkusen from "./leverkusen";
import Mags from "./mags";
// import History from "./history";

const DetailInfo = () => {
  const sperrmuelItemData = useAppSelector(
    (state) => state.sperrmuell.admin.sperrmuelItemInfo,
  );

  const generatePickupPlace = (type: string) => {
    switch (type) {
      case "awl": {
        return sperrmuelItemData?.pickupPlace
          ? sperrmuelItemData.pickupPlace
          : "-";
      }
      case "ebwo": {
        return `${sperrmuelItemData?.pickupStreet}, ${
          sperrmuelItemData?.pickupHomeNumber
        }${
          sperrmuelItemData?.pickupHausNrZusatz
            ? sperrmuelItemData?.pickupHausNrZusatz
            : ""
        }${
          sperrmuelItemData?.pickupHomeNumberTo
            ? ` - ${sperrmuelItemData?.pickupHomeNumberTo}`
            : ""
        }`;
      }
      case "lra": {
        return `${sperrmuelItemData?.pickupStreet} ${
          sperrmuelItemData?.pickupHomeNumber
        } ${
          sperrmuelItemData?.pickupHausNrZusatz
            ? `${sperrmuelItemData?.pickupHausNrZusatz}`
            : ""
        }${
          sperrmuelItemData?.pickupHomeNumberTo
            ? ` - ${sperrmuelItemData?.pickupHomeNumberTo}`
            : ""
        }${`, ${sperrmuelItemData?.postcode}`}${
          sperrmuelItemData?.pickupPlace
            ? `, ${sperrmuelItemData?.pickupPlace}`
            : ""
        }`;
      }
      case "leverkusen": {
        return `${sperrmuelItemData?.pickupStreet} ${
          sperrmuelItemData?.pickupHomeNumber
        } ${
          sperrmuelItemData?.pickupHausNrZusatz
            ? `${sperrmuelItemData?.pickupHausNrZusatz}`
            : ""
        }${
          sperrmuelItemData?.pickupHomeNumberTo
            ? ` - ${sperrmuelItemData?.pickupHomeNumberTo}`
            : ""
        }${`, ${sperrmuelItemData?.postcode}`}${
          sperrmuelItemData?.pickupPlace
            ? `, ${sperrmuelItemData?.pickupPlace}`
            : ""
        }`;
      }
      case "mags": {
        return `${sperrmuelItemData?.pickupStreet} ${
          sperrmuelItemData?.pickupHomeNumber
        } ${
          sperrmuelItemData?.pickupHausNrZusatz
            ? `${sperrmuelItemData?.pickupHausNrZusatz}`
            : ""
        }${
          sperrmuelItemData?.pickupHomeNumberTo
            ? ` - ${sperrmuelItemData?.pickupHomeNumberTo}`
            : ""
        }${`, ${sperrmuelItemData?.postcode}`}${
          sperrmuelItemData?.pickupPlace
            ? `, ${sperrmuelItemData?.pickupPlace}`
            : ""
        }`;
      }
      case "ebe": {
        return `${sperrmuelItemData?.pickupStreet} ${
          sperrmuelItemData?.pickupHomeNumber
        } ${
          sperrmuelItemData?.pickupHausNrZusatz
            ? `${sperrmuelItemData?.pickupHausNrZusatz}`
            : ""
        }${`, ${sperrmuelItemData?.postcode}`}${
          sperrmuelItemData?.pickupPlace
            ? `, ${sperrmuelItemData?.pickupPlace}`
            : ""
        }`;
      }
      default: {
        return "";
      }
    }
  };

  const items = [
    {
      title: "",
      items: [
        {
          rowTitle: "Status",
          rowInfo: sperrmuelItemData?.status
            ? statuses[sperrmuelItemData?.status]
            : "",
          isActive: ["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Datum (Meldung)",
          rowInfo: `${
            sperrmuelItemData?.createdAt
              ? format(
                  new Date(sperrmuelItemData?.createdAt),
                  "dd.MM.yyyy, HH:mm",
                  {
                    locale: de,
                  },
                )
              : ""
          }`,
          isActive: true,
        },
      ],
    },
    {
      title: "Personendaten",
      items: [
        {
          rowTitle: "Kassenzeichen",
          rowInfo: `${
            sperrmuelItemData?.buchungszeichen
              ? sperrmuelItemData?.buchungszeichen
              : ""
          }`,
          isActive: ["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Name",
          rowInfo: `${sperrmuelItemData?.userSurname}, ${sperrmuelItemData?.userName}`,
          isActive: true,
        },
        {
          rowTitle: "Straße",
          rowInfo: `${sperrmuelItemData?.street} ${
            sperrmuelItemData?.homeNumber
          } ${
            sperrmuelItemData?.hausNrZusatz
              ? " " + sperrmuelItemData?.hausNrZusatz
              : ""
          } ${
            sperrmuelItemData?.homeNumberTo
              ? ` - ${sperrmuelItemData?.homeNumberTo}`
              : ""
          }`,
          isActive: true,
        },
        {
          rowTitle: "Ort",
          rowInfo: `${
            sperrmuelItemData?.postcode ? `${sperrmuelItemData.postcode}` : ""
          }
            ${
              sperrmuelItemData?.pickupPlace
                ? `${sperrmuelItemData?.pickupPlace}`
                : ""
            }`,
          isActive: true,
        },
        {
          rowTitle: "Telefonnummer",
          rowInfo: `${
            sperrmuelItemData?.phoneNumber
              ? "+ " + sperrmuelItemData?.phoneNumber
              : ""
          }`,
          isActive: true,
        },
        {
          rowTitle: "Mobiltelefon",
          rowInfo: `${
            sperrmuelItemData?.mobilePhoneNumber
              ? `+ ${sperrmuelItemData.mobilePhoneNumber}`
              : "-"
          }`,
          isActive: ["awl"].includes(appConfig.logo),
        },
        {
          rowTitle: "E-Mail",
          rowInfo: `${sperrmuelItemData?.email}`,
          isActive: true,
        },
      ],
    },
    {
      title: "Bestelldaten",
      items: [
        {
          rowTitle: "Abweichender Abholort",
          rowInfo: `${generatePickupPlace(appConfig.logo)}`,
          isActive: !["calw"].includes(appConfig.logo),
        },
        // {
        //   rowTitle: "Bestelformular",
        //   rowInfo: `${sperrmuelItemData?.trashType ?? ''}`,
        //   isActive: ["calw"].includes(appConfig.logo),
        // },
        {
          rowTitle: "Servicetyp",
          rowInfo: `${sperrmuelItemData?.serviceType ?? ""}`,
          isActive: ["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Leistungen",
          rowInfo: ``,
          rowCustomItem: (
            <>
              {sperrmuelItemData?.pickUpTrash.map((i, idx) => {
                return (
                  <div
                    className={
                      sperrmuelItemData?.pickUpTrash &&
                      sperrmuelItemData?.pickUpTrash.length > 1
                        ? style.trashTypeWrapper
                        : ""
                    }
                    key={idx}
                  >
                    <div className={style.trashTypeTitle}>
                      {i.trashType}
                      {i.date === "Abfallberatung"
                        ? " Abfallberatung"
                        : ["ExpressService", "Expressservice"].includes(i.date)
                          ? " Express Service"
                          : i.date === "Selbstanlieferung"
                            ? "Selbstanlieferung"
                            : i.date
                              ? ` = ${format(
                                  new Date(i.date),
                                  "dd. MMMM yyyy",
                                  {
                                    locale: de,
                                  },
                                )}`
                              : ""}
                    </div>
                    {i.comment ? (
                      <div className={style.trashTypeComment}>
                        Kommentar: {i?.comment}
                      </div>
                    ) : null}
                    {i.pickupPlace ? (
                      <div className={style.trashTypeComment}>
                        Abweichender Abholort: {i?.pickupPlace}
                      </div>
                    ) : null}
                    {i.isBigAmount ? (
                      <div className={style.trashTypeComment}>
                        Haushaltsauflösung
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </>
          ),
          isActive: !["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Leistungsart",
          rowInfo: `${
            sperrmuelItemData?.trashType ? sperrmuelItemData?.trashType : ""
          }`,
          isActive: ["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Serviceart",
          rowInfo: `${
            sperrmuelItemData?.isExpressService
              ? "Expressservice"
              : "Standardservice"
          }`,
          isActive: ["calw"].includes(appConfig.logo),
        },
        {
          rowTitle: "Leistungsdatum",
          //sperrmuelItemData?.pickUpTrash[0].date === 'Abfallberatung' || sperrmuelItemData?.pickUpTrash[0].date === 'ExpressService'
          rowInfo: `${
            sperrmuelItemData?.pickUpTrash[0].date
              ? [
                  "Abfallberatung",
                  "ExpressService",
                  "Expressservice",
                  "Selbstanlieferung",
                ].includes(sperrmuelItemData?.pickUpTrash[0].date)
                ? sperrmuelItemData?.pickUpTrash[0].date
                : format(
                    new Date(sperrmuelItemData?.pickUpTrash[0].date),
                    "dd.MM.yyyy",
                    {
                      locale: de,
                    },
                  )
              : ""
          }`,
          isActive: ["calw", "lra"].includes(appConfig.logo),
        },
        {
          rowTitle: "Stückliste",
          rowInfo: ``,
          rowCustomItem: (
            <>
              {sperrmuelItemData?.trashTypeData?.map((el, idx) => {
                return (
                  <div
                    style={{
                      marginBottom:
                        sperrmuelItemData.trashTypeData &&
                        idx === sperrmuelItemData?.trashTypeData?.length - 1
                          ? "0"
                          : "10px",
                    }}
                    key={idx}
                  >
                    {el.name} - {el.value} Stück
                  </div>
                );
              })}
            </>
          ),
          isActive: ["calw", "lra"].includes(appConfig.logo),
        },
        {
          rowTitle: "Gesamt Sperrmüllvolumen",
          rowInfo: `${sperrmuelItemData?.trashVolume?.toFixed(2)}`,
          isActive: ["lra"].includes(appConfig.logo),
        },
        {
          rowTitle: "Nachricht",
          rowInfo: `${
            sperrmuelItemData?.message ? sperrmuelItemData.message : ""
          }`,
          isActive: ["mags"].includes(appConfig.logo) ? false : true,
        },
        {
          rowTitle: "Informationen zum Abholort",
          rowInfo: `${
            sperrmuelItemData?.abstellort ? sperrmuelItemData.abstellort : ""
          }`,
          isActive: ["mags"].includes(appConfig.logo),
        },
        ...(sperrmuelItemData?.abstellort
          ? [
              {
                rowTitle: "Abstellort",
                rowInfo: sperrmuelItemData?.abstellort,
                isActive: ["ebe"].includes(appConfig.logo),
              },
            ]
          : []),
      ],
    },
  ];

  return (
    <div>
      {items.map((el, idx) => {
        return (
          <AdminDetailInfoItem
            items={el.items.filter((el) => el.isActive)}
            title={el.title}
            key={idx}
          />
        );
      })}
      {appConfig.logo === "ebwo" ? <Ebwo /> : null}
      {appConfig.logo === "lra" ? <Lra /> : null}
      {appConfig.logo === "calw" ? <Calw /> : null}
      {appConfig.logo === "leverkusen" ? <Leverkusen /> : null}
      {appConfig.logo === "mags" ? <Mags /> : null}
    </div>
  );
};

export default DetailInfo;
